import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { Observable, map, firstValueFrom } from 'rxjs';
import { ChartData, ProductModel, ProductModelClass, ProductType, ProductTypeCategory, ProductTypeCoilConfig, ProductUnitSize, ProductVoltage, Project, ProjectSchedule, ProjectScheduleLineItem, UnitSize, } from '../models/dbmodels';
import { ConfigurationSet, PerformanceRequest, PerformanceResponseWSHP, PerformanceResponseFanCoil, PerformanceCoilRowOptionsRequest, PerformanceCoilRowOptionsResponse, PerformanceResponseBlowerCoils, FanCurveData } from '../models/config-view-models';
import { environment } from 'src/environments/environment';
import { PricingInputRequest, PricingInputResponse } from '../models/pricing-view-models';
import { ProductMotorVoltageResponse, ProductVoltageOptionsRequest, ProductVoltageOptionsResponse } from '../models/request-response-models';
import { FanSpeedChartRequest } from '../models/viewmodels';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private baseUrl: string = environment.apiUrl + "api/";// ?? "https://localhost:44397/api/";
  constructor(private http: HttpClient) { }

  public getAllProductType(): Observable<ProductType[]> {
    let apiUrl = this.baseUrl + "ProductType"
    return this.http.get<ProductType[]>(apiUrl);
  }

  public getByIdProductType(id: number): Observable<ProductType> {
    let apiUrl = this.baseUrl + "ProductType/" + id;
    return this.http.get<ProductType>(apiUrl);
  }

  public getAllProductTypeCategory(): Observable<ProductTypeCategory[]> {
    let apiUrl = this.baseUrl + "ProductTypeCategory"
    return this.http.get<ProductTypeCategory[]>(apiUrl);
  }

  public getAllProductModelClass(): Observable<ProductModelClass[]> {
    let apiUrl = this.baseUrl + "ProductModelClass"
    return this.http.get<ProductModelClass[]>(apiUrl);
  }

  public getAllProductModel(): Observable<ProductModel[]> {
    let apiUrl = this.baseUrl + "ProductModel"
    return this.http.get<ProductModel[]>(apiUrl);
  }

  public getAllProductUnitSize(): Observable<ProductUnitSize[]> {
    let apiUrl = this.baseUrl + "ProductUnitSize"
    return this.http.get<ProductUnitSize[]>(apiUrl);
  }

  public getAllUnitSize(): Observable<UnitSize[]> {
    let apiUrl = this.baseUrl + "UnitSize"
    return this.http.get<UnitSize[]>(apiUrl);
  }

  public getAllProject(): Observable<Project[]> {
    let apiUrl = this.baseUrl + "Project"
    return this.http.get<Project[]>(apiUrl);
  }

  public getAllProjectSchedule(): Observable<ProjectSchedule[]> {
    let apiUrl = this.baseUrl + "ProjectSchedule"
    return this.http.get<ProjectSchedule[]>(apiUrl);
  }

  public getAllProjectScheduleLineItem(): Observable<ProjectScheduleLineItem[]> {
    let apiUrl = this.baseUrl + "ProjectScheduleLineItem"
    return this.http.get<ProjectScheduleLineItem[]>(apiUrl);
  } 

   public getProductVoltageByProductModelId(productModelId: number): Observable<ProductVoltage[]> {
    let apiUrl = this.baseUrl + "ProductVoltage/GetByProductModel/";
    return this.http.get<ProductVoltage[]>(apiUrl + productModelId);
  } 

  public getVoltageOptionsByProductModelId(request: ProductVoltageOptionsRequest): Observable<ProductVoltageOptionsResponse> {
    let apiUrl = this.baseUrl + "ProductVoltage/GetVoltageOptionsByProductModel";///" + request.ProductModelId;
    //console.log("getVoltageOptionsByProductModelId request: " + JSON.stringify(request));
    return this.http.post<ProductVoltageOptionsResponse>(apiUrl, JSON.stringify(request), 
    { 
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  } 

  public getProductVoltageMotorsByProductModelId(request: ProductVoltageOptionsRequest): Observable<ProductMotorVoltageResponse> {
    let apiUrl = this.baseUrl + "ProductVoltage/GetProductMotorVoltages";
    //return this.http.get<ProductVoltageOptionsResponse>(apiUrl);
    return this.http.post(apiUrl, JSON.stringify(request), 
    { 
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  } 

  sendUploadCSV(fileName: string, fileContents: string, uploadType?: number, isFromEselect: boolean = false) {
    console.log("Uploading...");
    console.log("File " + fileName + " -> " +  fileContents);
    console.log("Upload Type -> " + uploadType);
    console.log(fileContents);
    console.log("path => " + this.baseUrl + "ExcelUploader/Upload/" + uploadType + "/" + isFromEselect);
    fileContents = fileContents.replaceAll("\"","").replaceAll("\\","\\\\");
    
    console.log("body", {fileContents: fileContents});
    console.log("body", {fileContents: JSON.stringify(fileContents)});
    let url = this.baseUrl + "ExcelUploader/Upload/" + uploadType + "/" + isFromEselect;
    console.log("Final URL: " + url);
    return this.http.post(url, JSON.stringify(fileContents), 
    { 
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  public downloadCSV(downloadType?: number) {
    console.log("downloadCSV in api service running");
    console.log(this.baseUrl + "ExcelUploader/Download/" + downloadType);
    
    return this.http.get(this.baseUrl + "ExcelUploader/Download/" + downloadType, {responseType: 'blob'});
  }

  public sendItemConfigForFilter(itemConfig: ConfigurationSet): Observable<PerformanceResponseFanCoil>{
    
    var response: ProductModelClass[] = [];
    return this.http.post<PerformanceResponseFanCoil>(this.baseUrl + "Integration/FilterProducts/", itemConfig);//.pipe(map((pmcs: ProductModelClass[]) => {console.log(pmcs); response = pmcs;}));

  }

  public getPerformanceCoilRowOptions(request: PerformanceCoilRowOptionsRequest): Observable<PerformanceCoilRowOptionsResponse>{
    
    return this.http.put<PerformanceCoilRowOptionsResponse>(this.baseUrl + "CoilProfile/GetCoilRowOptions", request);

  }

  public rrGetItemPerformance(request: PerformanceRequest): Observable<PerformanceResponseFanCoil>{
    
    return this.http.put<PerformanceResponseFanCoil>(this.baseUrl + "ItemSelection/GetRRResults", request);//.pipe(map((pmcs: ProductModelClass[]) => {console.log(pmcs); response = pmcs;}));

  }

  public wshpGetItemPerformance(request: PerformanceRequest): Observable<PerformanceResponseWSHP>{
    
    //var response: ProductModelClass[] = [];
    return this.http.put<PerformanceResponseWSHP>(this.baseUrl + "ItemSelection/GetWSHPResults", request);//.pipe(map((pmcs: ProductModelClass[]) => {console.log(pmcs); response = pmcs;}));

  }

  public BlowerCoilsGetItemPerformance(request: PerformanceRequest): Observable<PerformanceResponseBlowerCoils> {
    return this.http.put<PerformanceResponseBlowerCoils>(this.baseUrl + "ItemSelection/GetBlowerCoilResults", request);
  }

  public ervGetItemPerformance(request: PerformanceRequest): Observable<PerformanceResponseFanCoil>{
    console.log("ERV Request: ", request);
    return this.http.put<PerformanceResponseFanCoil>(this.baseUrl + "ItemSelection/GetERVResults", request);//.pipe(map((pmcs: ProductModelClass[]) => {console.log(pmcs); response = pmcs;}));

  }

  public create<T>(obj: T, apiName: string) : Observable<T> {
    let url = this.baseUrl + apiName
    var responseObject;
    return this.http.post<T>(url,obj);
  }

  public update<T>(obj: T, apiName: string) : any {
    let url = this.baseUrl + apiName
    return this.http.put<T>(url,obj).subscribe((resp: T | undefined) => {
      //console.log(resp);
      return resp;
    });
  }

  public updateObs<T>(obj: T, apiName: string) : Observable<T> {
    let url = this.baseUrl + apiName
    return this.http.put<T>(url,obj);
  }

  public get<T>(apiName: string) : Observable<T> {
    let url = this.baseUrl + apiName
    //console.log("getting " + url);
    return this.http.get<T>(url);
  }

  public post<T1,T2>(apiName: string, data: T1): Observable<T2>{
    return this.http.post<T2>(this.baseUrl + apiName, data);
  }

  public put<T1,T2>(apiName: string, data: T1): Observable<T2>{
    return this.http.put<T2>(this.baseUrl + apiName, data);
  }
  
  public async getWithRef<T>(apiName: string, obj: T) : Promise<T> {
    let url = this.baseUrl + apiName
    var responseObject;
    return this.http.get<T>(url).toPromise();
  }

  public async getSynced<T>(apiName: string) : Promise<Awaited<T>> {
    let url = this.baseUrl + apiName
    var responseObject;
    responseObject = await firstValueFrom(this.http.get<T>(url));
    return responseObject;
  }

public getAllFanSpeedChartData(airFlowProfileId: number): Promise<FanCurveData> {

  const apiUrl = this.baseUrl + `AirFlowProfile/GetAllFanSpeedChartData/${airFlowProfileId}`;

  // firstValueFrom returns a Promise<ChartData[]>
  return firstValueFrom(this.http.get<FanCurveData>(apiUrl));
}

}
